import { Link } from "react-router-dom";

const PreviewCard = ({ item, type, onLinkClick }) => {
  if (!item) return null;

  const linkPath = type === "project" ? `/projects#${item.id}` : `/#${item.id}`;

  return (
    <Link
      to={linkPath}
      className="skills__preview-card"
      onClick={(e) => onLinkClick(e, linkPath)}
    >
      <div className="skills__preview-title">
        <h5>{type === "project" ? item.name : item.company}</h5>
        <h6>{type === "project" ? null : item.role}</h6>
      </div>
    </Link>
  );
};

export default PreviewCard;
